import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { DeviceConfigurerServiceSharedModule } from '../../shared';

import {
    ImageResourceService,
    ImageResourcePopupService,
    ImageResourceComponent,
    ImageResourceDetailComponent,
    ImageResourceDialogComponent,
    ImageResourcePopupComponent,
    ImageResourceDeletePopupComponent,
    ImageResourceDeleteDialogComponent,
    imageResourceRoute,
    imageResourcePopupRoute,
    ImageResourceResolvePagingParams,
} from './';

let ENTITY_STATES = [
    ...imageResourceRoute,
    ...imageResourcePopupRoute,
];

@NgModule({
    imports: [
        DeviceConfigurerServiceSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        ImageResourceComponent,
        ImageResourceDetailComponent,
        ImageResourceDialogComponent,
        ImageResourceDeleteDialogComponent,
        ImageResourcePopupComponent,
        ImageResourceDeletePopupComponent,
    ],
    entryComponents: [
        ImageResourceComponent,
        ImageResourceDialogComponent,
        ImageResourcePopupComponent,
        ImageResourceDeleteDialogComponent,
        ImageResourceDeletePopupComponent,
    ],
    providers: [
        ImageResourceService,
        ImageResourcePopupService,
        ImageResourceResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DeviceConfigurerServiceImageResourceModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/image-resource/image-resource.module.ts